module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


//////////////////
// WEBPACK FOOTER
// external "@ba/ba-ui-carbon-toolkit"
// module id = 2
// module chunks = 0